<template>
 

    <v-layout wrap>
      <v-flex lg4 md4 sm4>
        <v-card>
          <div id="chart">
            <apexchart
              type="line"
              :options="userCourseChartOptions"
              :series="userCourseSeries"
            ></apexchart>
          </div>
        </v-card>
      </v-flex>
     
      <v-flex md4 sm6 lg3>
        <v-card>
          <div id="chart">
            <apexchart
              type="pie"
              :options="genderChartOptions"
              :series="genderSeries"
            />
          </div>
        </v-card>
      </v-flex>


      <v-flex md4 sm6 lg3>
        <v-card>
          <div id="chart">
            <apexchart
              type="pie"
              :options="countryChartOptions"
              :series="countrySeries"
            />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import bus from "../bus";
import { setTimeout } from 'timers';
import { mapGetters, mapActions, mapState } from "vuex";

import Pusher from 'pusher-js'
const socket = new Pusher('8b7b2278694ce750e2e5', {
  cluster: 'mt1',
  encrypted: true
})
const channel = socket.subscribe('newLecture')
const channelNewUser = socket.subscribe('newUser')
const channelViewLecture = socket.subscribe('viewLecture')


export default {


  components: {
    apexchart: VueApexCharts
  },

  computed: {
    ...mapState('dashboard', ['lectureCountList',
    'courseList',
    'lectureOption',
    'lectureSeries',
    'genderSeries',
    'genderChartOptions',
    'countrySeries',
    'countryChartOptions',
    'userCourseChartOptions',
    'userCourseSeries',
    'liveStreamingNumber']),
  },
  data() {
    return {
      devices: [],
      valueLive: [],
      users: [],
      streamingVideos: [],
      options: {
        chart: {
          id: "bar-chart"
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
          categories: ['Users', 'Devices', 'Live Streaming']
        }
      },
      series: [
        {
          name: "Device graph",
          data: []
        }
      ],

      pie_series: [45, 55, 70],
      chartOptions: {
        labels: ["Female", "Male", "Not mentioned", ],
        theme: {
          monochrome: {
            enabled: true
          }
        },
        title: {
          text: "Number of leads"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]
      }
    };
  },
  watch: {
   
  },
  created() {
  let self = this
  channelNewUser.bind('user-created', function (data) {
      console.log(data);
      self.getUserNumberByCountry()
      self.getUserNumberByGender()
      // this.valueLive = 3
    });

  self.getLecturesNumberForLMS()
  self.getUserNumberByGender()
  self.getUserNumberByCountry()
  self.getTodayVideos()
  self.getUserNumberByCourse()
  },
  methods: {
    ...mapActions("dashboard", ["getLecturesNumberForLMS", 'setLiveStreamingNumber', 'getUserNumberByGender', 'getUserNumberByCountry', 'getUserNumberByCourse', 'getTodayVideos']),

  }
};
</script>